import type { HostedAuthPlugin } from '@unipile/ui';
import { Wizard } from './components/Wizard';

export const telegramHaPlugin: HostedAuthPlugin = {
  Component: Wizard,
  registerTrads({ locales, i18n }) {
    return Promise.all(
      locales.map(async (locale) => {
        const data: { default: object } = await import(`./translations/${locale}.json`);
        i18n.addResourceBundle(locale, 'telegram', data.default);
      }),
    );
  },
};
